(function () {
  const BACKEND_URL = 'https://j88tx9zh4i.execute-api.us-east-1.amazonaws.com';

  // Guarda gclid en sessionStorage cuando está en la URL de entrada
  (function storeAttribution() {
    const p = new URLSearchParams(window.location.search);
    if (p.get('gclid')) sessionStorage.setItem('rc_gclid', p.get('gclid'));
    if (p.get('gbraid')) sessionStorage.setItem('rc_gbraid', p.get('gbraid'));
    if (p.get('wbraid')) sessionStorage.setItem('rc_wbraid', p.get('wbraid'));
  })();

  function getCookie(name) {
    const m = document.cookie.match('(^| )' + name + '=([^;]+)');
    return m ? decodeURIComponent(m[2]) : null;
  }

  function getAttribution() {
    const p = new URLSearchParams(window.location.search);
    return {
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc') || p.get('fbclid'),
      gclid: sessionStorage.getItem('rc_gclid') || p.get('gclid'),
      gbraid: sessionStorage.getItem('rc_gbraid'),
      wbraid: sessionStorage.getItem('rc_wbraid')
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    const triggerBtn = document.getElementById('cart-refurbicredit-btn');
    const overlay    = document.getElementById('rc-modal-overlay');
    const closeBtn   = document.getElementById('rc-modal-close');
    const form       = document.getElementById('rc-customer-form');
    const errorEl    = document.getElementById('rc-form-error');
    const submitBtn  = form ? form.querySelector('[type="submit"]') : null;

    // Actualiza hero y totales con datos frescos del carrito
    function updateCartTotals(cart) {
      var fmt = window.money_format || '${{amount_with_comma_separator}}';
      var grandFormatted = Shopify.formatMoney(cart.total_price, fmt);
      var subFormatted   = Shopify.formatMoney(cart.original_total_price, fmt);

      var heroEl = document.querySelector('.rc-cart-hero__total');
      if (heroEl) heroEl.textContent = 'El total de tu carrito es de ' + grandFormatted;

      var grandEl = document.querySelector('.rc-totals__grand [data-cart-total-value]');
      if (grandEl) {
        grandEl.textContent = grandFormatted;
        grandEl.setAttribute('data-cart-total-value', cart.total_price);
      }

      var subEl = document.querySelector('.rc-totals__row span:last-child');
      if (subEl) subEl.textContent = subFormatted;
    }

    // Toast de deshacer: barra superior animada con opción de re-añadir el item eliminado
    function showUndoToast(name, onUndo, onDismiss) {
      var existing = document.querySelector('.rc-undo-toast');
      if (existing) existing.parentNode.removeChild(existing);

      var toast = document.createElement('div');
      toast.className = 'rc-undo-toast';
      toast.innerHTML =
        '<span>' + (name || 'El producto') + ' se ha eliminado de tu carrito</span>' +
        '<button class="rc-undo-toast__undo" type="button">Deshacer</button>' +
        '<button class="rc-undo-toast__close" type="button" aria-label="Cerrar">&#x2715;</button>';
      document.body.appendChild(toast);
      requestAnimationFrame(function () { toast.classList.add('rc-undo-toast--visible'); });

      var done = false;
      function dismiss() {
        if (done) return; done = true;
        toast.classList.remove('rc-undo-toast--visible');
        setTimeout(function () { toast.parentNode && toast.parentNode.removeChild(toast); }, 320);
      }

      var timer = setTimeout(function () { dismiss(); onDismiss && onDismiss(); }, 6000);
      toast.querySelector('.rc-undo-toast__undo').addEventListener('click', function () {
        clearTimeout(timer); dismiss(); onUndo();
      });
      toast.querySelector('.rc-undo-toast__close').addEventListener('click', function () {
        clearTimeout(timer); dismiss(); onDismiss && onDismiss();
      });
    }

    // Fuente de verdad: la respuesta de /cart/change.js (estado YA confirmado por el servidor).
    // Tanto "Eliminar" como el stepper −/+ de Halo pasan por aquí vía Shopify.removeItem/changeItem.
    (function interceptCartChange() {
      var origFetch = window.fetch;

      // Captura de click en fase de captura: antes de que Halo procese el evento
      // Guardamos el elemento DOM y los datos necesarios para el undo.
      // data-index="{{ item.index | plus: 1 }}" es lo que getCartUpdate envía como body.line
      var pending = null;

      document.addEventListener('click', function (e) {
        // Caso: botón "Eliminar"
        var removeBtn = e.target.closest('[data-cart-remove]');
        // Caso: botón "−" del stepper
        var minusBtn  = !removeBtn && e.target.closest('[data-minus-quantity-cart]');
        if (!removeBtn && !minusBtn) return;

        var li = e.target.closest('.cart-item');
        if (!li || li.classList.contains('is-refurbicare')) return;

        // Para el botón "−": solo capturar si la cantidad actual es 1 (va a llegar a 0)
        if (minusBtn) {
          var qtyInput = li.querySelector('[data-cart-quantity]');
          if (!qtyInput || parseInt(qtyInput.value) > 1) return;
          removeBtn = li.querySelector('[data-cart-remove]');
          if (!removeBtn) return;
        }

        var nameEl = li.querySelector('.cart-item-name .text');
        pending = {
          element:   li,
          name:      nameEl ? nameEl.textContent.trim() : null,
          variantId: removeBtn.dataset.cartRemoveId,
          quantity:  (function () {
            var q = li.querySelector('[data-cart-quantity]');
            return q ? (parseInt(q.value) || 1) : 1;
          })(),
          // Halo envía { id: item.key } en /cart/change.js — item.key === data-line
          lineKey: removeBtn.dataset.line
        };
      }, true); // fase de captura = antes de que Halo detenga la propagación

      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var promise = origFetch.apply(this, arguments);
        if (!/\/cart\/change(\.js)?(\?|$)/.test(url)) return promise;

        // Determinar si esta llamada corresponde a la eliminación pendiente capturada.
        // Halo envía { id: item.key, quantity: 0 } — el id coincide con data-line del item.
        var toUndo = null;
        try {
          var reqBody = init && init.body ? JSON.parse(init.body) : {};
          var changeKey = reqBody.id || reqBody.line; // soporta ambas variantes
          if (reqBody.quantity === 0 && changeKey && pending) {
            if (!pending.lineKey || String(pending.lineKey) === String(changeKey)) {
              toUndo = pending;
            }
            pending = null;
          }
        } catch (e) {}

        // Ocultar el elemento inmediatamente al confirmar el servidor (sin esperar el re-render de Halo)
        return promise.then(function (response) {
          response.clone().json().then(function (cart) {
            if (!cart || typeof cart.item_count !== 'number') return;

            function doReload() { window.location.reload(); }
            function addBack() {
              if (!toUndo || !toUndo.variantId) { doReload(); return; }
              origFetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-RefurbiCare': '1' },
                body: JSON.stringify({ id: parseInt(toUndo.variantId), quantity: toUndo.quantity })
              }).then(doReload).catch(doReload);
            }

            // Ocultar el item eliminado + su slot RefurbiCare (ambos comparten data-line = item.key).
            // Inyectamos una regla CSS con !important en vez de tocar .style: el repaint de
            // RefurbiCare (global.js, ~500ms tras /cart/change) recrea el slot y revertiría display:none.
            // La regla persiste aunque el slot se recree, mientras conserve su data-line.
            if (toUndo && toUndo.lineKey) {
              var key = toUndo.lineKey;
              // animación de salida suave antes de que la regla colapse el espacio
              document.querySelectorAll('.cart-item, .rc-cart-slot').forEach(function (node) {
                if (node.getAttribute('data-line') === key) {
                  node.style.transition = 'opacity 0.15s';
                  node.style.opacity = '0';
                }
              });
              var sheet = document.getElementById('rc-hidden-lines');
              if (!sheet) {
                sheet = document.createElement('style');
                sheet.id = 'rc-hidden-lines';
                document.head.appendChild(sheet);
              }
              setTimeout(function () {
                sheet.textContent +=
                  '.cart-item[data-line="' + key + '"],.rc-cart-slot[data-line="' + key + '"]{display:none!important}';
                // El primer item que quede visible pierde su divisor superior
                // (:first-child del CSS sigue apuntando al item oculto, que aún está en el DOM).
                var items = document.querySelectorAll('.cart-list > .cart-item');
                for (var i = 0; i < items.length; i++) {
                  var dl = items[i].getAttribute('data-line');
                  if (items[i].classList.contains('is-refurbicare') || dl === key) continue;
                  sheet.textContent += '.cart-list>.cart-item[data-line="' + dl + '"]{border-top:none!important}';
                  break;
                }
              }, 160);
            }

            if (cart.item_count === 0) {
              showUndoToast(toUndo && toUndo.name, addBack, doReload);
            } else {
              updateCartTotals(cart);
              if (toUndo) showUndoToast(toUndo.name, addBack, null);
            }
          }).catch(function () {});
          return response;
        });
      };
    })();

    // Modal informativo "¿Qué es RefurbiCredit?"
    (function initInfoModal() {
      var infoOverlay = document.getElementById('rc-info-modal-overlay');
      if (!infoOverlay) return;

      function openInfo() { infoOverlay.style.display = 'flex'; }
      function closeInfo() { infoOverlay.style.display = 'none'; }

      ['rc-info-btn-hero', 'rc-info-btn-footer'].forEach(function (id) {
        var btn = document.getElementById(id);
        if (btn) btn.addEventListener('click', openInfo);
      });

      document.getElementById('rc-info-modal-close').addEventListener('click', closeInfo);
      infoOverlay.addEventListener('click', function (e) {
        if (e.target === infoOverlay) closeInfo();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && infoOverlay.style.display === 'flex') closeInfo();
      });
    })();

    // RefurbiCare añade un plan vía /cart/add.js (no pasa por change) → escucha su evento propio
    document.addEventListener('refurbicare:cart-updated', function (e) {
      if (e.detail && e.detail.cart) updateCartTotals(e.detail.cart);
    });

    // A partir de aquí, lógica del modal: requiere que existan botón/overlay/form
    if (!triggerBtn || !overlay || !form) return;

    // Abrir modal
    triggerBtn.addEventListener('click', function () {
      overlay.style.display = 'flex';
      overlay.querySelector('input')?.focus();
    });

    // Cerrar modal
    closeBtn?.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    function closeModal() {
      overlay.style.display = 'none';
      if (errorEl) errorEl.style.display = 'none';
    }

    // Envío del formulario
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (errorEl) errorEl.style.display = 'none';

      submitBtn.disabled = true;
      submitBtn.textContent = 'Procesando…';

      try {
        // 1. Obtener carrito actual
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        if (!cart.item_count) {
          throw new Error('El carrito está vacío.');
        }

        const lineItems = cart.items.map(item => ({
          variantId:    item.variant_id,
          productId:    item.product_id,
          title:        item.product_title || item.title,
          quantity:     item.quantity,
          price:        String(item.price),
          sku:          item.sku || '',
          isRefurbicare: !!(item.properties && (
            item.properties.__rc_type ||
            item.properties.__rc_parent_product_id
          ))
        }));

        // 2. Datos del cliente desde el formulario
        const fd = new FormData(form);
        const customer = {
          firstName:      fd.get('firstName')?.trim(),
          lastName:       fd.get('lastName')?.trim(),
          email:          fd.get('email')?.trim(),
          phone:          fd.get('phone')?.trim(),
          documentNumber: fd.get('documentNumber')?.trim(),
          address1:       fd.get('address1')?.trim(),
          city:           fd.get('city')?.trim(),
          province:       fd.get('province')?.trim(),
          zip:            fd.get('zip')?.trim() || ''
        };

        // 3. Atribución
        const attribution = getAttribution();

        // 4. Llamar al backend
        const res = await fetch(BACKEND_URL + '/credit-request', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            lineItems,
            customer,
            total: String(cart.total_price),
            attribution
          })
        });

        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.message || 'Error del servidor (' + res.status + ')');
        }

        const { url } = await res.json();
        window.location.href = url;

      } catch (err) {
        console.error('[RefurbiCredit]', err);
        if (errorEl) {
          errorEl.textContent = err.message || 'Ocurrió un error. Intenta de nuevo.';
          errorEl.style.display = 'block';
        }
        submitBtn.disabled = false;
        submitBtn.textContent = 'Continuar a RefurbiCredit';
      }
    });
  });
})();
